export class CursoCmd {
  nome: string = ''
  descricao: string = ''
  dataInicio: string = ''
  dataFim: string = ''
}
